// src/pages/admin/AdminDashboard.jsx
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import BannerList from './BannerList';
import GameList  from './GameList';
import EventList from './EventList';
import GameJamList from './GameJamList';

export default function AdminDashboard() {
  const location = useLocation();
  // 넘어온 state.tab이 있으면 그걸, 없으면 'banners'
  const initialTab = location.state?.tab || 'banners';
  const [tab, setTab] = useState(initialTab);

  return (
    <div className="container mx-auto px-6 py-8 min-h-screen">
      {/* 탭 네비게이션 */}
      <div className="mb-6">
        <ul className="flex space-x-8 text-lg font-medium">
          <li
            className={`cursor-pointer pb-2 transition-colors ${
              tab === 'banners'
                ? 'border-b-2 border-red-600 text-red-600'
                : 'text-gray-400'
            }`}
            onClick={() => setTab('banners')}
          >
            배너 관리
          </li>
          <li
            className={`cursor-pointer pb-2 transition-colors ${
              tab === 'games'
                ? 'border-b-2 border-red-600 text-red-600'
                : 'text-gray-400'
            }`}
            onClick={() => setTab('games')}
          >
            게임 관리
          </li>
          
          <li
            className={`cursor-pointer pb-2 transition-colors ${
              tab === 'events'
                ? 'border-b-2 border-red-600 text-red-600'
                : 'text-gray-400'
            }`}
            onClick={() => setTab('events')}
          >
            이벤트 관리
          </li>
          <li
            className={`cursor-pointer pb-2 transition-colors ${
              tab === 'gamejams'
                ? 'border-b-2 border-red-600 text-red-600'
                : 'text-gray-400'
            }`}
            onClick={() => setTab('gamejams')}
          >
            게임잼 관리
          </li>
        </ul>
      </div>

      {/* 콘텐츠 렌더링 */}
      {tab === 'banners'  && <BannerList />}
      {tab === 'games'    && <GameList />}
      {tab === 'events'   && <EventList onCount={() => {}} />}
      {tab === 'gamejams' && <GameJamList />}
    </div>
  );
}
